"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentsClientImpl = void 0;
const HttpClientImpl_1 = require("./HttpClientImpl");
class PaymentsClientImpl extends HttpClientImpl_1.HttpClientImpl {
    constructor(options, prefix) {
        super(options);
        this.getConfig = async () => {
            return this.get(`${this.prefix}/config`);
        };
        this.signup = async (request) => {
            return this.post(`${this.prefix}/signup`, request);
        };
        this.createCheckoutSession = async (request) => {
            return this.post(`${this.prefix}/checkoutsession`, request);
        };
        this.getCheckoutSession = async (sessionId) => {
            return this.get(`${this.prefix}/checkoutsession?sessionId=${sessionId}`);
        };
        this.createPortalSession = async () => {
            return this.post(`${this.prefix}/portalsession`);
        };
        this.fetchSubscriptions = async () => {
            return this.get(`${this.prefix}/subscriptions`);
        };
        this.prefix = `${prefix}/v1/payments`;
    }
}
exports.PaymentsClientImpl = PaymentsClientImpl;
